import '../../static/css/templ/sidenav.css';
import {NavLink} from "react-router-dom";
import {CurrencyFormat} from "../techaran/money";
import {ThinDiamondIcon, ThinShoppingCartIcon} from "../icons/material-icons";

export const Sidenav = (props: {
    panel: 'admins' | 'parents', items: {
        to: string | null,
        icon: JSX.Element | null,
        name: string | null,
        count: number | null,
        hide: boolean,
        available: boolean,
        unavailableClick: any,
    }[]
}) => {
    const closeSideOnMobile = () => {
        (document.querySelector('.sidenav') as HTMLElement).classList.remove('open');
        (document.querySelector('.sidenav-underlay') as HTMLElement).classList.remove('active');
    };
    return (
        <>
            <div className="sidenav-underlay d-md-none" onClick={closeSideOnMobile}/>
            <div className={"sidenav active"}>
                <div>
                    {
                        props.items.map((d, i) => {
                            if (d.hide)
                                return null;
                            else if (!d.available)
                                return (
                                    <button key={"K38dj38" + i} onClick={d.unavailableClick}>
                                        <div>
                                            {d.icon}
                                            <i>{d.name}</i>
                                        </div>
                                        <em className={"open-tooltip"}>
                                            <ThinDiamondIcon/>
                                            <i>خرید امکان</i>
                                        </em>
                                    </button>
                                );
                            else if (d.name !== null && d.to !== null && d.icon !== null)
                                return (
                                    <NavLink to={d.to} key={"K38dj38" + i} onClick={closeSideOnMobile}>
                                        {d.icon}
                                        <i>{d.name}</i>
                                        {
                                            d.count !== null && d.count > 0 ?
                                                <em>{d.count > 99 ? '+۹۹' : CurrencyFormat(d.count)}</em> : null
                                        }
                                    </NavLink>
                                );
                            else
                                return <hr key={"K38dj382" + i}/>;
                        })
                    }
                </div>
            </div>
        </>
    );
};